import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

ChartJS.defaults.plugins.datalabels = {
  display: false,
};

const Budget2026Chart = () => {
  // Categories + Total Values
  const labels = ["Federal Funds", "Overlap Funds", "State Funds"];

  const values = [8.3, 10.7, 11.8]; // Totals you showed in screenshot

  const colors = ["#6E11B0", "#ea9999", "#D62828"]; // Purple, Peach Pink, Red

  const data = {
    labels,
    datasets: [
      {
        label: "Amount (Billion $)",
        data: values,
        backgroundColor: colors,
        borderRadius: 10,
        barThickness: 45,
      },
    ],
  };

  const options = {
    indexAxis: "y", // Horizontal bar
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: { display: false },

      title: {
        display: true,
        text: "Utah Budget FY 2026",
        color: "#111",
        font: { size: 22, weight: "bold" },
        padding: { bottom: 20 },
      },

      tooltip: {
        callbacks: {
          label: (context) => {
            const val = context.parsed.x || 0;
            return ` Amount (Billion $) - ${val.toFixed(2)}`;
          },
        },
      },

      datalabels: {
        display: true,
        color: "#fff",
        anchor: "end",
        align: "left",
        formatter: (value) => value.toFixed(2),
        font: { weight: "bold", size: 13 },
      },
    },

    scales: {
      x: {
        beginAtZero: true,
        max: 12,
        title: {
          display: true,
          text: "Amount (Billion $)",
          font: { weight: "bold" },
          color: "#111",
        },
        ticks: { color: "#333" },
        grid: { color: "#ccc" },
      },
      y: {
        ticks: {
          color: "#000",
          font: { size: 14, weight: "600" },
        },
        grid: { display: false },
      },
    },
  };

  return (
    <div className="overflow-x-auto mt-6">
      <div className="p-3 bg-white rounded-3 border min-w-[900px] sm:min-w-full">
        <div
          style={{
            width: "100%",
            height: "400px",
            padding: "40px",
            borderRadius: "10px",
          }}
        >
          <Bar data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default Budget2026Chart;
